<button
  [class.secondary]="type === 'secondary'"
  [class.with-text]="!!buttonText"
  [class.expandable]="expandable"
  [class.preview-button]="previewButton"
>
  <ng-container *ngIf="!showLoadingIndicator; else spinner">
    <span class="icon-container" [class.d-none-important]="!iconName && !lottieAnimationOptions">
      <ng-lottie
        *ngIf="lottieAnimationOptions; else svgIcon"
        [options]="lottieAnimationOptions"
        (animationCreated)="onAnimationCreated($event)"
      ></ng-lottie>
      <ng-template #svgIcon>
        <svg-icon [key]="iconName" [attr.data-testid]="'MovieDetailsPage.myList' + iconName"></svg-icon>
      </ng-template>
    </span>
    <span class="icon-text">{{ buttonText }}</span>
  </ng-container>

  <ng-template #spinner>
    <osn-shared-loading-spinner [type]="'dark'" [size]="25"></osn-shared-loading-spinner>
  </ng-template>
</button>
